import { Modal as Popup } from 'react-bootstrap'

export default function Modal(props) {

    const { show, size, handleClose, header, headerAction, FormPage, children, enforceFocus } = props

    return (
        <>
            <Popup
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size={size || 'md'}
                centered
                enforceFocus={enforceFocus !== false}
            >
                <Popup.Header className='d-flex justify-content-between align-items-center ps-3 pe-3'>
                    <Popup.Title as='h5' className="mb-0">{header}</Popup.Title>
                    <div className="d-flex align-items-center gap-2">
                        {headerAction}
                        <button type="button" className="btn-close" aria-label="Close" onClick={handleClose} />
                    </div>
                </Popup.Header>
                <Popup.Body>
                    {children || (FormPage ? <FormPage /> : null)}
                </Popup.Body>
            </Popup>
        </>
    )
}
